import { getPaginated, patch, post } from '@/api/base'
import { i18n } from '@/i18n'

const exportsApi = {
  getAll: async () => {
    const response = await getPaginated({ path: 'exports', valuePath: 'exports' })
    return response.success ? response.values : []
  },
  create: async params => {
    return await post({ path: 'exports', params, options: { notificationMessage: i18n.t('exports.createFile') } })
  },
  update: async (exportUuid, params) => {
    return await patch({ path: `exports/${exportUuid}`, params, options: { skipNotify: true } })
  },
}

export default exportsApi
